import { render, staticRenderFns } from "./OfferPayToChatMen.vue?vue&type=template&id=cdd660b0&"
import script from "./OfferPayToChatMen.vue?vue&type=script&lang=js&"
export * from "./OfferPayToChatMen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports